if(typeof __WEBPACK_EXTERNAL_MODULE__4436__ === 'undefined') { var e = new Error("Cannot find module 'vtk.js'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = __WEBPACK_EXTERNAL_MODULE__4436__;